"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IDENTITY_CLIENT_ID = void 0;
const IDENTITY_CLIENT_ID = exports.IDENTITY_CLIENT_ID = 'SPADev';
